export default __webpack_public_path__ + "static/loading-truck-72da58c2c097588009ad45bc60d082ce.png";